var _path, _line, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeTrapeze5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 700,
    viewBox: "0 0 400 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 126H346.5L210 416.5V579H122V126Z",
    stroke: "white",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 122.775,
    y1: 580.861,
    x2: 207.775,
    y2: 414.861,
    stroke: "#A9A9A9",
    strokeWidth: 5,
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 357 116)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 132 116)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 220 569)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 220 406)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 132 569)",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126L93.6603 141L76.3397 141L85 126ZM85 579L76.3397 564L93.6602 564L85 579ZM86.5 139.5L86.5 565.5L83.5 565.5L83.5 139.5L86.5 139.5Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122 90L137 81.3397V98.6603L122 90ZM347 90L332 98.6603V81.3397L347 90ZM135.5 88.5L333.5 88.5V91.5L135.5 91.5V88.5Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122 615L137 606.34V623.66L122 615ZM210 615L195 623.66V606.34L210 615ZM135.5 613.5H196.5V616.5H135.5V613.5Z",
    fill: "#929292"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5227 365V335.909H49.0455V348.864H64.5568V335.909H68.0795V365H64.5568V351.989H49.0455V365H45.5227Z",
    fill: "#929292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.523 70V40.9091H227.045V66.875H240.568V70H223.523ZM253.903 40.9091V70H250.38V44.6023H250.21L243.107 49.3182V45.7386L250.38 40.9091H253.903Z",
    fill: "#929292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.523 668V638.909H151.045V664.875H164.568V668H147.523ZM169.511 668V665.443L179.114 654.932C180.241 653.701 181.169 652.631 181.898 651.722C182.627 650.803 183.167 649.941 183.517 649.136C183.877 648.322 184.057 647.47 184.057 646.58C184.057 645.557 183.811 644.671 183.318 643.923C182.835 643.175 182.172 642.598 181.33 642.19C180.487 641.783 179.54 641.58 178.489 641.58C177.371 641.58 176.396 641.812 175.562 642.276C174.739 642.73 174.099 643.369 173.645 644.193C173.2 645.017 172.977 645.983 172.977 647.091H169.625C169.625 645.386 170.018 643.89 170.804 642.602C171.59 641.314 172.66 640.311 174.014 639.591C175.378 638.871 176.907 638.511 178.602 638.511C180.307 638.511 181.817 638.871 183.134 639.591C184.45 640.311 185.482 641.281 186.23 642.503C186.978 643.724 187.352 645.083 187.352 646.58C187.352 647.65 187.158 648.696 186.77 649.719C186.391 650.732 185.728 651.864 184.781 653.114C183.844 654.354 182.542 655.869 180.875 657.659L174.341 664.648V664.875H187.864V668H169.511Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeTrapeze5);
export default __webpack_public_path__ + "static/media/node_trapeze_5.e239c4e1de8514aedb86a9bd779331c3.svg";
export { ForwardRef as ReactComponent };